/*!
 * @project: 최초의 봉인, 화룡
 * @author: NCSOFT
 * @update: 2017-12-12 16:59:17
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _wheelDirection = __webpack_require__(1);

var _wheelDirection2 = _interopRequireDefault(_wheelDirection);

var _isPreventTime = __webpack_require__(2);

var _isPreventTime2 = _interopRequireDefault(_isPreventTime);

var _intro = __webpack_require__(3);

var _intro2 = _interopRequireDefault(_intro);

var _bossOne = __webpack_require__(4);

var _bossOne2 = _interopRequireDefault(_bossOne);

var _bossTwo = __webpack_require__(5);

var _bossTwo2 = _interopRequireDefault(_bossTwo);

var _bossThree = __webpack_require__(6);

var _bossThree2 = _interopRequireDefault(_bossThree);

var _heroOne = __webpack_require__(7);

var _heroOne2 = _interopRequireDefault(_heroOne);

var _storyOne = __webpack_require__(8);

var _storyOne2 = _interopRequireDefault(_storyOne);

var _storyTwo = __webpack_require__(9);

var _storyTwo2 = _interopRequireDefault(_storyTwo);

var _dungeonOne = __webpack_require__(10);

var _dungeonOne2 = _interopRequireDefault(_dungeonOne);

var _gunnerOne = __webpack_require__(11);

var _gunnerOne2 = _interopRequireDefault(_gunnerOne);

var _systemOne = __webpack_require__(12);

var _systemOne2 = _interopRequireDefault(_systemOne);

var _systemTwo = __webpack_require__(13);

var _systemTwo2 = _interopRequireDefault(_systemTwo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var intro = new _intro2.default();
var bossOne = new _bossOne2.default();
var bossTwo = new _bossTwo2.default();
var bossThree = new _bossThree2.default();
var heroOne = new _heroOne2.default();
var storyOne = new _storyOne2.default();
var storyTwo = new _storyTwo2.default();
var dungeonOne = new _dungeonOne2.default();
var gunnerOne = new _gunnerOne2.default();
var systemOne = new _systemOne2.default();
var systemTwo = new _systemTwo2.default();

var page = { intro: intro, bossOne: bossOne, bossTwo: bossTwo, bossThree: bossThree, heroOne: heroOne, storyOne: storyOne, storyTwo: storyTwo, dungeonOne: dungeonOne, gunnerOne: gunnerOne, systemOne: systemOne, systemTwo: systemTwo };

var context = $('.section-page');
var nowCount = 0;
var maxCount = 10;
var target = {};
var init = {};
var timer = void 0;
var slideArea = $('.slide-area');
var initLayer = $('.movie-init');
var currentPage = ['intro', 'intro1'];
var DOM_MovieLayer = $('.layer-movie');
var DOM_MovieLayer_full = $('.full-layer-movie');
var DOM_MovieLayer_full2 = $('.full-layer-movie2');
var DOM_MovieLayer_full3 = $('.full-layer-movie3');

var setPage = function setPage(direction) {
    if (nowCount + direction < 0 || nowCount + direction > maxCount) return;
    nowCount = nowCount + direction;

    render(nowCount);
};

var render = function render(renderId) {
    var go = void 0,
        id = void 0;

    var _pageMap = pageMap(renderId);

    var _pageMap2 = _slicedToArray(_pageMap, 2);

    go = _pageMap2[0];
    id = _pageMap2[1];


    var query = go + id;

    if (currentPage) {
        page[currentPage[0]].reset(currentPage[1]);
    }

    setNaviActive(query);

    page[go].start(query);
    $('.menu').removeClass('open');
    currentPage = [go, query];
};

var setNaviActive = function setNaviActive(query) {
    $('.nav-list a').removeClass('active');

    switch (query) {
        case 'bossOne1':
        case 'bossTwo1':
        case 'bossThree1':
            $('.nav-01 > a').addClass('active');
            break;
        case 'heroOne1':
            $('.nav-02 > a').addClass('active');
            break;
        case 'storyOne1':
        case 'storyTwo1':
            $('.nav-03 > a').addClass('active');
            break;
        case 'dungeonOne1':
            $('.nav-04 > a').addClass('active');
            break;
        case 'gunnerOne1':
            $('.nav-05 > a').addClass('active');
            break;
        case 'systemOne1':
        case 'systemTwo1':
            $('.nav-06 > a').addClass('active');
            break;
    }
};

var pageMap = function pageMap(value) {
    var map = {
        0: ['intro', 1],
        1: ['bossOne', 1],
        2: ['bossTwo', 1],
        3: ['bossThree', 1],
        4: ['heroOne', 1],
        5: ['storyOne', 1],
        6: ['storyTwo', 1],
        7: ['dungeonOne', 1],
        8: ['gunnerOne', 1],
        9: ['systemOne', 1],
        10: ['systemTwo', 1]
    };

    return map[value];
};

var naviMap = function naviMap(value) {
    var map = {
        '#page-intro': 0,
        '#page-boss1': 1,
        '#page-boss2': 2,
        '#page-boss3': 3,
        '#page-hero1': 4,
        '#page-story1': 5,
        '#page-story2': 6,
        '#page-dungeon1': 7,
        '#page-gunner1': 8,
        '#page-system1': 9,
        '#page-system2': 10
    };
    return map[value];
};

var config = {
    isSoundPlay: false,
    isPlayerSoundStop: false
};

$(document).on('click', '.btn-link-bgm', function (e) {
    e.originalEvent && (config.isPlayerSoundStop = !config.isPlayerSoundStop);

    e.preventDefault();
    var $self = void 0;

    $self = $(this);

    if (config.isSoundPlay && $self.hasClass('play')) {
        config.isSoundPlay = false;
        soundManager.pause('sound');
        $self.removeClass('play').addClass('pause');
    } else {
        config.isSoundPlay = true;
        soundManager.play('sound');
        $self.removeClass('pause').addClass('play');
    }
});

$(document).on('click', '.btn-link-index', function (e) {
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

$(document).on('click', '.cmplay .btn-close', function (e) {
    e.preventDefault();
    $('.cmplay').hide();
});

$(document).on('click', '.nav-list a', function (e) {
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

init.videoBg = new nc.ui.Player({
    selector: '#bg-video-init',
    videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/fd_intro.mp4',
    mute: false,
    autoPlay: false,
    loop: false
});
nc.ui.Player.movieLayer = new nc.ui.Player({
    selector: '#movie-box',
    videoId: 'RjANlnUxVBk',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

nc.ui.Player.movieLayerFull = new nc.ui.Player({
    selector: '#movie-box-full',
    videoId: 'ZpFj1UxF0x4',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

nc.ui.Player.movieLayerFull2 = new nc.ui.Player({
    selector: '#movie-box-full2',
    videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/fd_story.mp4',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

nc.ui.Player.movieLayerFull3 = new nc.ui.Player({
    selector: '#movie-box-full3',
    videoId: '6KeMAEKWyhc',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

$(document).on('click', '.menu-trigger', function (e) {
    e.preventDefault();
    $('.menu').addClass('open');
});
$(document).on('click', '.menu-close', function (e) {
    e.preventDefault();
    $('.menu').removeClass('open');
});

$(document).on('click', '.btn-open-event', function (e) {
    e.preventDefault();
    $(this).closest('.event-wrap').toggleClass('open');
});

$(document).on('click', '.btn-link-movie', function (e) {
    e.preventDefault();
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer_full.fadeIn();
    nc.ui.Player.movieLayerFull.play();
    $(window).trigger('resize');
});

$(document).on('click', '.btn-link-cmplay', function (e) {
    e.preventDefault();

    config.isSoundPlay && $('.btn-link-bgm').trigger('click');

    DOM_MovieLayer.fadeIn();

    nc.ui.Player.movieLayer.play();

    $(window).trigger('resize');
});
$(document).on('click', '.btn-view-content-movie', function (e) {
    e.preventDefault();
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer_full3.fadeIn();
    nc.ui.Player.movieLayerFull3.play();
    $(window).trigger('resize');
});
$(document).on('click', '.btn-play-flamemovie', function (e) {
    e.preventDefault();
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer_full2.fadeIn();
    nc.ui.Player.movieLayerFull2.play();
    $(window).trigger('resize');
});
$(document).on('click', '.btn-view-cm', function (e) {
    e.preventDefault();
    $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer.fadeIn();
    nc.ui.Player.movieLayer.play();
    $(window).trigger('resize');
});

$(document).on('click', '.layer-movie .btn-close', function (e) {
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayer.stop();
    DOM_MovieLayer.hide();
});

$(document).on('click', '.full-layer-movie .btn-close', function (e) {
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayerFull.stop();
    DOM_MovieLayer_full.hide();
});

$(document).on('click', '.full-layer-movie2 .btn-close', function (e) {
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayerFull2.stop();
    DOM_MovieLayer_full2.hide();
});

$(document).on('click', '.full-layer-movie3 .btn-close', function (e) {
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayerFull2.stop();
    DOM_MovieLayer_full3.hide();
});

$(document).on('click', '.btn-link-skip', function (e) {
    e.preventDefault();

    init.videoBg.pause();
    initLayer.fadeOut();

    $('.container').css({
        'visibility': 'visible'
    });
    page['intro'].start('intro1');

    clearTimeout(timer);

    $('.header').addClass('animate');
    $('.btn-link-bgm').trigger('click');
});

context.on('mousewheel DOMMouseScroll', function (e) {
    e.stopPropagation();
    if ((0, _isPreventTime2.default)(window.lastWheelTime)) return;
    window.lastWheelTime = new Date().getTime();

    setPage((0, _wheelDirection2.default)(e));
});
$('.nav-list li').hover(function () {
    $(this).addClass('hover');
}, function () {
    $(this).removeClass('hover');
});

new nc.promo.preloader({
    'drawSize': 5,
    'resourcePath': '/promo/bns/history/2017/171206_flamedragon',
    'preLoadList': ['/img/system/bg-obj6-2-2-img.png', '/img/system/bg-obj6-2-movie.jpg', '/img/system/bg-system1.jpg', '/img/system/bg-system2-1-blur.jpg', '/img/system/bg-system2-1-full.jpg', '/img/system/bg-system2-1.jpg', '/img/system/bg-system2-2-blur.jpg', '/img/system/bg-system2-2-full.jpg', '/img/system/bg-system2-2.jpg', '/img/system/bg-system2.jpg', '/img/system/obj6-1-banner1.png', '/img/system/obj6-1-chr1.png', '/img/system/obj6-1-chr2.png', '/img/system/obj6-1-chr3.png', '/img/system/obj6-1-chr4.png', '/img/system/obj6-1-tit.png', '/img/system/obj6-1-txt1.png', '/img/system/obj6-2-1-txt1.png', '/img/system/obj6-2-tit.png', '/img/system/txt-system2-1.png', '/img/system/txt-system2-2.png', '/img/story/bg-movie-3-1.jpg', '/img/story/bg-slide-area.png', '/img/story/bg-story.jpg', '/img/story/circle-slider.png', '/img/story/frame-movie-layer.png', '/img/story/img-area-1-1.jpg', '/img/story/img-area-1-2.jpg', '/img/story/img-area-1-3.jpg', '/img/story/img-area-1-4.jpg', '/img/story/img-area-2-1.jpg', '/img/story/img-area-2-2.jpg', '/img/story/img-area-2-3.jpg', '/img/story/img-area-2-4.jpg', '/img/story/img-area-3-1.jpg', '/img/story/img-area-3-2.jpg', '/img/story/img-area-3-3.jpg', '/img/story/img-area-3-4.jpg', '/img/story/obj3-1-chr1.png', '/img/story/obj3-1-chr2.png', '/img/story/obj3-1-chr3.png', '/img/story/obj3-1-chr4.png', '/img/story/obj3-1-sd.png', '/img/story/obj3-1-tit.png', '/img/story/obj3-1-txt1.png', '/img/story/obj3-2-tit.png', '/img/story/obj3-2-txt1.png', '/img/story/pager.png', '/img/intro/bg-arrow.png', '/img/intro/bg-intro.jpg', '/img/intro/btn-cmmovie.png', '/img/intro/btn-reservation.png', '/img/intro/btn-update.png', '/img/intro/obj0-chr1.png', '/img/intro/obj0-chr2.png', '/img/intro/obj0-chr3.png', '/img/intro/obj0-chr4.png', '/img/intro/obj0-chr5.png', '/img/intro/obj0-chr6.png', '/img/intro/obj0-chr7.png', '/img/intro/quick-links.png', '/img/intro/tit_intro_1.png', '/img/intro/txt-copyright.png', '/img/intro/txt-scroll.png', '/img/hero/bg-hero.jpg', '/img/hero/bg-movie-2-1.jpg', '/img/hero/frame-movie-layer.png', '/img/hero/obj2-1-chr1.png', '/img/hero/obj2-1-tit.png', '/img/hero/obj2-1-txt1.png', '/img/hero/obj2-1-txt2.png', '/img/gunner/bg-gunner.jpg', '/img/gunner/obj5-1-chr1-tip.png', '/img/gunner/obj5-1-chr1.png', '/img/gunner/obj5-1-chr2.png', '/img/gunner/obj5-1-tit.png', '/img/gunner/obj5-1-txt1.png', '/img/dungeon/bg-dungeon1-blur.jpg', '/img/dungeon/bg-dungeon1-full.jpg', '/img/dungeon/bg-dungeon1.jpg', '/img/dungeon/bg-dungeon2-blur.jpg', '/img/dungeon/bg-dungeon2-full.jpg', '/img/dungeon/bg-dungeon2.jpg', '/img/dungeon/bg-dungeon3-blur.jpg', '/img/dungeon/bg-dungeon3-full.jpg', '/img/dungeon/bg-dungeon3.jpg', '/img/dungeon/bg_dungeon_close.png', '/img/dungeon/obj4-1-chr1-eff.png', '/img/dungeon/obj4-1-chr1-tip.png', '/img/dungeon/obj4-1-chr1.png', '/img/dungeon/obj4-1-chr2-eff.png', '/img/dungeon/obj4-1-chr2-tip.png', '/img/dungeon/obj4-1-chr2.png', '/img/dungeon/obj4-1-tit.png', '/img/dungeon/obj4-1-txt1.png', '/img/dungeon/obj4-2-chr1-eff.png', '/img/dungeon/obj4-2-chr1-tip.png', '/img/dungeon/obj4-2-chr1.png', '/img/dungeon/obj4-2-tit.png', '/img/dungeon/obj4-2-txt1.png', '/img/dungeon/obj4-3-chr1-eff.png', '/img/dungeon/obj4-3-chr1-tip.png', '/img/dungeon/obj4-3-chr1.png', '/img/dungeon/obj4-3-tit.png', '/img/dungeon/obj4-3-txt1.png', '/img/dungeon/shadow-detail.png', '/img/dungeon/tit-dungeon1-1.png', '/img/dungeon/tit-dungeon1-2.png', '/img/dungeon/tit-dungeon1-3.png', '/img/dungeon/txt-dungeon1-1.png', '/img/dungeon/txt-dungeon1-2.png', '/img/dungeon/txt-dungeon1-3.png', '/img/common/arw_slide_next.png', '/img/common/arw_slide_prev.png', '/img/common/bg-back.jpg', '/img/common/bg-logo.jpg', '/img/common/bg-menu-close.png', '/img/common/bg-shadow.png', '/img/common/bg-shadow2.png', '/img/common/bg-shadow3.png', '/img/common/bg-util.png', '/img/common/bg-video.png', '/img/common/btn-dots-on.jpg', '/img/common/btn-open-event.png', '/img/common/btn-skip.png', '/img/common/btn_close.png', '/img/common/event-list.jpg', '/img/common/event-movie.jpg', '/img/common/logo-top.png', '/img/common/navi.png', '/img/common/pause.png', '/img/common/play.png', '/img/common/sns-share.png', '/img/boss/bg-boss.jpg', '/img/boss/bg-boss1.jpg', '/img/boss/obj1-1-chr1-eff.png', '/img/boss/obj1-1-chr1-sd.png', '/img/boss/obj1-1-chr1.png', '/img/boss/obj1-1-chr2.png', '/img/boss/obj1-1-tit.png', '/img/boss/obj1-1-txt1.png', '/img/boss/obj1-2-chr1-eff.png', '/img/boss/obj1-2-chr1-sd.png', '/img/boss/obj1-2-chr1.png', '/img/boss/obj1-2-chr2.png', '/img/boss/obj1-2-tit.png', '/img/boss/obj1-2-txt1.png', '/img/boss/obj1-3-chr1-eff.png', '/img/boss/obj1-3-chr1-sd.png', '/img/boss/obj1-3-chr1.png', '/img/boss/obj1-3-chr2.png', '/img/boss/obj1-3-tit1.png', '/img/boss/obj1-3-tit2.png', '/img/boss/obj1-3-txt1.png', '/img/boss/obj1-3-txt2.png'],
    'game': 'bns'
});

$(document).on('preLoaded', function () {
    $('.container').css({
        'visibility': 'visible'
    });

    $('.container').addClass('screen-ready');

    if (/#(page-boss1|page-hero1|page-story1|page-dungeon1|page-gunner1|page-system1)/.test(window.location.hash)) {
        initLayer.hide();
        nowCount = naviMap(window.location.hash);
        render(nowCount);

        $('.header').addClass('animate');
        $('.btn-link-bgm').trigger('click');
    } else {
        init.videoBg.play();

        timer = setTimeout(function () {
            initLayer.fadeOut();
            init.videoBg.pause();
            page['intro'].start('intro1');
            $('.header').addClass('animate');
            $('.btn-link-bgm').trigger('click');
        }, 9000);
    }
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function WheelDirection(e) {
    if (e.type === 'DOMMouseScroll') return e.originalEvent.detail > 0 ? 1 : -1;
    if (e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY > 0 ? -1 : 1;
    return e.originalEvent.wheelDelta > 0 ? -1 : 1;
}

exports.default = WheelDirection;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function isPreventTime(diffTime) {
    var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1200;

    return new Date().getTime() - diffTime < to;
}

exports.default = isPreventTime;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Intro = function () {
    function Intro() {
        _classCallCheck(this, Intro);

        this.context = null;
        this.pageActive = {};

        TweenMax.to('.btn-link-scroll span', 1.5, { delay: 2, top: -61, yoyo: true, repeat: -1, ease: Power0.easeNone });
    }

    _createClass(Intro, [{
        key: "start",
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            $("#container").addClass("hide-footer");
            this.context.removeClass('animate-out');
        }
    }, {
        key: "reset",
        value: function reset(page) {
            this.pageActive[page] = false;
            $("#container").removeClass("hide-footer");
            this.context && this.context.removeClass('animate-in');
            this.context && this.context.addClass('animate-out');
            this.context && this.context.find('.active').removeClass('active');
        }
    }, {
        key: "intro1",
        value: function intro1() {

            this.context = $('.section-page__intro');
            this.context.addClass('animate-intro');
            this.context.find('.obj0-tit').addClass('active');
            this.context.find('.obj0-chr1').addClass('active');
            this.context.find('.obj0-chr2').addClass('active');
            this.context.find('.obj0-chr3').addClass('active');
            this.context.find('.obj0-chr4').addClass('active');
            this.context.find('.obj0-chr5').addClass('active');
            this.context.find('.obj0-chr6').addClass('active');
            this.context.find('.obj0-chr7').addClass('active');
            this.context.find('.cmplay').addClass('active');
            this.context.find('.btn-link-scroll').addClass('active');
            this.context.find('.copyright').addClass('active');
            this.context.find('.quick-links').addClass('active');
            this.context.find('.btn-link-reservation').addClass('active');
        }
    }]);

    return Intro;
}();

exports.default = Intro;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BossOne = function () {
    function BossOne() {
        _classCallCheck(this, BossOne);

        this.context = null;
        this.pageActive = {};
        TweenMax.to('.obj1-1-chr1 .eff', 1.5, { delay: .5, opacity: .5, yoyo: true, repeat: -1, ease: Power0.easeNone });
    }

    _createClass(BossOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'bossOne1',
        value: function bossOne1() {
            this.context = $('.section-page__boss1');
            this.context.addClass('animate-in');
            this.context.find('.obj1-1-tit').addClass('active');
            this.context.find('.obj1-1-txt1').addClass('active');
            this.context.find('.obj1-1-chr1').addClass('active');
            this.context.find('.obj1-1-chr2').addClass('active');
        }
    }]);

    return BossOne;
}();

exports.default = BossOne;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BossTwo = function () {
    function BossTwo() {
        _classCallCheck(this, BossTwo);

        this.context = null;
        this.pageActive = {};

        TweenMax.to('.obj1-2-chr1 .eff', 1.5, { delay: .5, opacity: .5, yoyo: true, repeat: -1, ease: Power0.easeNone });
    }

    _createClass(BossTwo, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'bossTwo1',
        value: function bossTwo1() {
            this.context = $('.section-page__boss2');
            this.context.addClass('animate-in');
            this.context.find('.obj1-2-tit').addClass('active');
            this.context.find('.obj1-2-txt1').addClass('active');
            this.context.find('.obj1-2-chr1').addClass('active');
            this.context.find('.obj1-2-chr2').addClass('active');
        }
    }]);

    return BossTwo;
}();

exports.default = BossTwo;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BossThree = function () {
    function BossThree() {
        _classCallCheck(this, BossThree);

        this.context = null;
        this.pageActive = {};
        TweenMax.to('.obj1-3-chr1 .eff', 1.5, { delay: .5, opacity: .5, yoyo: true, repeat: -1, ease: Power0.easeNone });
    }

    _createClass(BossThree, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'bossThree1',
        value: function bossThree1() {
            this.context = $('.section-page__boss3');
            this.context.addClass('animate-in');
            this.context.find('.obj1-3-tit1').addClass('active');
            this.context.find('.obj1-3-txt1').addClass('active');
            this.context.find('.obj1-3-tit2').addClass('active');
            this.context.find('.obj1-3-txt2').addClass('active');
            this.context.find('.obj1-3-chr1').addClass('active');
            this.context.find('.obj1-3-chr2').addClass('active');
        }
    }]);

    return BossThree;
}();

exports.default = BossThree;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeroOne = function () {
    function HeroOne() {
        _classCallCheck(this, HeroOne);

        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }

    _createClass(HeroOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            var _this = this;

            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
            setTimeout(function () {
                if (!_this.pageActive[page]) {
                    _this.videoBg[page] && _this.videoBg[page].stop();
                }
            }, 1000);
        }
    }, {
        key: 'heroOne1',
        value: function heroOne1() {
            this.context = $('.section-page__hero1');
            this.context.addClass('animate-in');
            this.context.find('.obj2-1-tit').addClass('active');
            this.context.find('.obj2-1-txt1').addClass('active');
            this.context.find('.obj2-1-txt2').addClass('active');
            this.context.find('.obj2-1-box1').addClass('active');
            this.context.find('.obj2-1-chr1').addClass('active');

            this.playBg('HeroOne1');
        }
    }, {
        key: 'setBg',
        value: function setBg() {
            this.videoBg.HeroOne1 = new nc.ui.Player({
                selector: '#bg-video-hero1',
                videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/bimuhero_high.mp4',
                mute: true,
                autoPlay: false,
                loop: true
            });
        }
    }, {
        key: 'playBg',
        value: function playBg(id) {
            var _this2 = this;

            if (this.videoBgReady[id]) {
                this.videoBg[id].play();
            }

            var checkReady = setInterval(function () {
                _this2.videoBgReady[id] = _this2.videoBg[id].player.state.isReady;
                if (_this2.videoBgReady[id]) {
                    _this2.videoBg[id].play();
                    clearInterval(checkReady);
                }
            }, 100);
        }
    }]);

    return HeroOne;
}();

exports.default = HeroOne;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StoryOne = function () {
    function StoryOne() {
        _classCallCheck(this, StoryOne);

        this.context = null;
        this.pageActive = {};
    }

    _createClass(StoryOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'storyOne1',
        value: function storyOne1() {
            this.context = $('.section-page__story1');
            this.context.addClass('animate-in');
            this.context.find('.obj3-1-tit').addClass('active');
            this.context.find('.obj3-1-txt1').addClass('active');
            this.context.find('.obj3-1-movie').addClass('active');
            this.context.find('.obj3-1-chr1').addClass('active');
            this.context.find('.obj3-1-chr2').addClass('active');
            this.context.find('.obj3-1-chr3').addClass('active');
            this.context.find('.obj3-1-chr4').addClass('active');
        }
    }]);

    return StoryOne;
}();

exports.default = StoryOne;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StoryTwo = function () {
    function StoryTwo() {
        _classCallCheck(this, StoryTwo);

        this.context = null;
        this.pageActive = {};
        $(".slide-area").slick({
            infinite: false,
            dots: false,
            fade: true,
            speed: 600,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            arrows: false,
            swipe: false
        });
        $(".slide-area1").slick({
            infinite: true,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            dots: true,
            fade: true,
            arrows: true,
            prevArrow: '.area-prev01',
            nextArrow: '.area-next01'
        });
        $(".slide-area2").slick({
            infinite: true,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            dots: true,
            fade: true,
            arrows: true,
            prevArrow: '.area-prev02',
            nextArrow: '.area-next02'
        });
        $(".slide-area3").slick({
            infinite: true,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            dots: true,
            fade: true,
            arrows: true,
            prevArrow: '.area-prev03',
            nextArrow: '.area-next03'
        });

        var currentAreaSlide = $('.slide-area').slick('slickCurrentSlide');
        $(".slide-wrap").removeClass("slider-pager1 slider-pager2 slider-pager3");
        $(".slide-wrap").addClass("slider-pager" + (currentAreaSlide + 1));
        $("a", ".pager-area li").removeClass("on");
        $("a", ".pager-area li").eq(currentAreaSlide).addClass("on");
        $(".btn-group li").hide();
        $(".btn-group li").eq(currentAreaSlide).show();
        $("a", ".pager-area li").click(function (e) {
            e.preventDefault();
            $(".slide-wrap").removeClass("slider-pager1 slider-pager2 slider-pager3");
            $("a", ".pager-area li").removeClass("on");
            $(".btn-group li").hide();
            $(this).addClass("on");
            var index = $(this).closest("li").index();
            $(".slide-wrap").addClass("slider-pager" + (index + 1));
            $(".btn-group li").eq(index).show();
            $(".slide-area").slick("slickGoTo", parseInt(index));
        });
    }

    _createClass(StoryTwo, [{
        key: "start",
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: "reset",
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: "storyTwo1",
        value: function storyTwo1() {
            this.context = $('.section-page__story2');
            this.context.addClass('animate-in');
            $(".slide-area").slick('refresh');
            $(".slide-area1").slick('refresh');
            $(".slide-area2").slick('refresh');
            $(".slide-area3").slick('refresh');
            $(window).resize();
            this.context.find('.obj3-2-tit').addClass('active');
            this.context.find('.obj3-2-txt1').addClass('active');
            this.context.find('.obj3-2-area').addClass('active');
        }
    }]);

    return StoryTwo;
}();

exports.default = StoryTwo;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DungeonOne = function () {
    function DungeonOne() {
        _classCallCheck(this, DungeonOne);

        this.context = null;
        this.pageActive = {};
    }

    _createClass(DungeonOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
            this.context.find('.btn-close').trigger('click');
        }
    }, {
        key: 'dungeonOne1',
        value: function dungeonOne1() {
            this.context = $('.section-page__dungeon1');
            this.context.addClass('animate-in');
        }
    }]);

    return DungeonOne;
}();

exports.default = DungeonOne;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GunnerOne = function () {
    function GunnerOne() {
        _classCallCheck(this, GunnerOne);

        this.context = null;
        this.pageActive = {};
    }

    _createClass(GunnerOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'gunnerOne1',
        value: function gunnerOne1() {
            this.context = $('.section-page__gunner1');
            this.context.addClass('animate-in');
            this.context.find('.obj5-1-tit').addClass('active');
            this.context.find('.obj5-1-txt1').addClass('active');
            this.context.find('.obj5-1-chr1').addClass('active');
            this.context.find('.obj5-1-chr2').addClass('active');
        }
    }]);

    return GunnerOne;
}();

exports.default = GunnerOne;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SystemOne = function () {
    function SystemOne() {
        _classCallCheck(this, SystemOne);

        this.context = null;
        this.pageActive = {};
    }

    _createClass(SystemOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'systemOne1',
        value: function systemOne1() {
            this.context = $('.section-page__system1');
            this.context.addClass('animate-in');
            this.context.find('.obj6-1-tit').addClass('active');
            this.context.find('.obj6-1-txt1').addClass('active');
            this.context.find('.obj6-1-banner1').addClass('active');
            this.context.find('.obj6-1-chr1').addClass('active');
            this.context.find('.obj6-1-chr2').addClass('active');
            this.context.find('.obj6-1-chr3').addClass('active');
            this.context.find('.obj6-1-chr4').addClass('active');
        }
    }]);

    return SystemOne;
}();

exports.default = SystemOne;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SystemTwo = function () {
    function SystemTwo() {
        _classCallCheck(this, SystemTwo);

        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }

    _createClass(SystemTwo, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            var _this = this;

            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
            this.context.find('.btn-close').trigger('click');

            setTimeout(function () {
                if (!_this.pageActive[page]) {
                    _this.videoBg[page] && _this.videoBg[page].stop();
                }
            }, 1000);
        }
    }, {
        key: 'systemTwo1',
        value: function systemTwo1() {
            this.context = $('.section-page__system2');
            this.context.addClass('animate-in');
            this.context.find('.obj6-2-tit').addClass('active');
            this.context.find('.content').addClass('active');

            this.playBg('systemTwo1');
        }
    }, {
        key: 'setBg',
        value: function setBg() {
            this.videoBg.systemTwo1 = new nc.ui.Player({
                selector: '#movie-6-2',
                videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/skillskin_low.mp4',
                mute: true,
                autoPlay: false,
                loop: true
            });
        }
    }, {
        key: 'playBg',
        value: function playBg(id) {
            var _this2 = this;

            if (this.videoBgReady[id]) {
                setTimeout(function () {
                    _this2.videoBg[id].play();
                }, 800);
            }

            var checkReady = setInterval(function () {
                _this2.videoBgReady[id] = _this2.videoBg[id].player.state.isReady;
                if (_this2.videoBgReady[id]) {
                    setTimeout(function () {
                        _this2.videoBg[id].play();
                        clearInterval(checkReady);
                    }, 800);
                }
            }, 100);
        }
    }]);

    return SystemTwo;
}();

exports.default = SystemTwo;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js